/*  COSA C'E' SCRITTO DAVVERO, al posto del bottone «Salva».

    Dal 04/10/2026 nella scheda del preventivo non ci sono piu' bottoni di salvataggio
    salvo «Salva la riga»: quello che si scrive si scrive uscendo dalla casella, e quello
    che si sceglie — una spunta, una tendina — nel momento in cui lo si sceglie.

    Ma il bottone faceva anche un'altra cosa, e non si poteva buttare insieme a lui: era
    l'unico modo di sapere, SENZA PROVARCI, che quello che si vede e' quello che e'
    scritto. Spento voleva dire «siamo pari». Senza niente al suo posto, uno che ha
    appena cambiato un numero e non vede succedere nulla non sa se ha salvato o se si e'
    dimenticato, e l'unico modo di scoprirlo sarebbe ricaricare la pagina.

    Quindi al suo posto c'e' una riga che dice lo stato, e dice la stessa cosa che diceva
    il bottone spento — con il vantaggio che non chiede di premerla.
*/
export function StatoScrittura({
  inCorso,
  allineato,
}: {
  /** Una scrittura e' in volo adesso. */
  inCorso: boolean;
  /** Quello che si vede e' quello che e' scritto sul documento. */
  allineato: boolean;
}) {
  if (inCorso) return <p className="stato-scrittura in-volo">Salvo…</p>;

  return allineato ? (
    <p className="stato-scrittura">Salvato</p>
  ) : (
    /*  Non «non salvato», che suona come un guasto: e' lo stato normale di chi sta
        ancora scrivendo dentro la casella, e la frase dice cosa fare per uscirne.  */
    <p className="stato-scrittura da-scrivere">Si salva uscendo dalla casella</p>
  );
}
